import { Controller } from "stimulus";

export default class extends Controller {
  connect() {
    this.subNav = document.querySelector('.journal-sub-nav__select')
    this.mobileMenu = document.querySelector('.journal-sub-nav .menu-container')
  }

  toggleOptions(event) {
    if (this.subNav.value.includes('?category') || this.subNav.value.includes('?tag')) {
      window.location.search = this.subNav.value
    } else {
      window.location = this.subNav.value
    }
  }

  closeMenu() {
    this.mobileMenu.classList.remove('active')
    document.body.style.overflow = "auto";
  }

  openMenu() {
    this.mobileMenu.classList.add('active')
    document.body.style.overflow = "hidden";
  }
}
